import { RefreshCw, TriangleAlert } from 'lucide-react';

import { IconTile } from '@/design-system/patterns/IconTile';
import { Button } from '@/design-system/ui/Button';

export type ErrorStateProps = {
  title?: string;
  description?: string;
  onRetry: () => void;
  retryLabel?: string;
  /** Código para quem for investigar ("NET-503"). */
  code?: string;
};

/**
 * Falha ao carregar, com o próximo passo à vista. A mensagem não distingue rede,
 * servidor ou contrato: para quem usa, o que fazer é o mesmo.
 */
export default function ErrorState({
  title = 'Não foi possível carregar os dados',
  description = 'A conexão com o servidor falhou. Suas alterações salvas não foram perdidas. Verifique sua internet e tente novamente.',
  onRetry,
  retryLabel = 'Tentar novamente',
  code,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className="mx-auto my-12 flex max-w-130 flex-col items-center gap-2.5 rounded-dialog border border-line-card bg-white px-7 py-8 text-center"
    >
      <IconTile tone="danger" size="xl">
        <TriangleAlert />
      </IconTile>
      <h2 className="m-0 text-title-sm font-bold">{title}</h2>
      <p className="m-0 text-control text-pretty text-ink-muted">{description}</p>
      <Button className="mt-2" onClick={onRetry}>
        <RefreshCw aria-hidden />
        {retryLabel}
      </Button>
      {code ? <p className="m-0 text-caption text-ink-subtle">Código do erro: {code}</p> : null}
    </div>
  );
}
